<!-- 我的信息 -->
<template>
    <div class="content">
        <div class="formBigBox">
            <div class="formTitle">个人信息</div>
            <el-form class="formBox">
                <el-form-item label="头像" label-width="80px" required>
                    <el-upload
                        class="avatar-uploader"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="账号" label-width="80px" required v-show="userPhone">
                    <div class="textsbox" style=" height:40px;display: flex;align-items: center;">
                        {{ userPhone }}
                    </div>
                </el-form-item>
                <el-form-item label="昵称" label-width="80px" required>
                    <div class="inputs">
                        <el-input v-model="form.name" placeholder="请输入昵称"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="真实姓名" label-width="80px" required>
                    <div class="inputs">
                        <el-input v-model="form.realname" placeholder="请输入真实姓名"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="邮箱" label-width="80px" required>
                    <div class="inputs">
                        <el-input v-model="form.email" placeholder="请输入邮箱用于接收文献"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="性别" label-width="80px" required>
                    <el-radio-group v-model="form.gender">
                        <el-radio label="男"></el-radio>
                        <el-radio label="女"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="注册身份" label-width="80px" required>
                    <el-select v-model="form.registerediidentity" placeholder="请选择注册身份">
                        <el-option v-for="(item, index) in registerediidentityList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="医院名称" label-width="80px" required>
                    <div class="inputs changeHospit" @click="dialogVisible = true">
                        {{ form.hospitName }}
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button style="margin-left: 100px;" type="primary" @click="updateUser('ruleForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="formBigBox">
            <div class="formTitle">认证信息</div>
            <div class="clickBox">
                执业医师认证 
                <span @click="dialogVisible2 = true" v-if="Statue == 0 && Userlevel == 0">去认证</span>
                <span v-if="Statue == 0 && Remarks3 == 1">审核中</span>
                <span @click="dialogVisible2 = true" v-if="Statue == 0 && Remarks3 == 2">审核失败 重新认证</span>
                <span v-if="Statue != 0">已认证</span>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" 
            width="740px"
            :close-on-click-modal="false"
            title="选择医院"
            :destroy-on-close="true"
            >
            <div class="noteList">
                <div class="selectBox">
                    <el-select v-model="value1" clearable placeholder="请选择省" style="margin-right:20px;">
                        <el-option
                        v-for="item in options1"
                        :key="item.provinceID"
                        :label="item.province"
                        :value="item.provinceID">
                        </el-option>
                    </el-select>
                    <el-select v-model="value2" clearable placeholder="请选择市" style="margin-right:20px;">
                        <el-option
                        v-for="item in options2"
                        :key="item.cityID"
                        :label="item.city"
                        :value="item.cityID">
                        </el-option>
                    </el-select>
                    <el-select v-model="value3" clearable placeholder="请选择区">
                        <el-option
                        v-for="item in options3"
                        :key="item.areaID"
                        :label="item.area"
                        :value="item.areaID">
                        </el-option>
                    </el-select>
                </div>
                <div class="searchInput">
                    <el-input class="searchVal" v-model="hospitKeyword" placeholder="输入医院信息"></el-input>
                    <el-button type="primary" @click="getHospitList()">查询</el-button>
                    <el-button type="primary" @click="openNewHospial()">新建医院</el-button>
                </div>
                <el-table
                    :data="hospitTableData"
                    height="250"
                    border
                    style="width: 100%">
                    <el-table-column
                        prop="Name"
                        label="医院名称"
                        width="500">
                    </el-table-column>
                    <el-table-column
                        label="操作">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="text" size="small">选择医院</el-button>
                        </template>
                        </el-table-column>
                </el-table>
            </div>
		</el-dialog>
        
        
        <el-dialog :visible.sync="dialogVisible1" 
            width="540px"
            :close-on-click-modal="false"
            title="新建医院"
            :destroy-on-close="true"
            >
            <div class="noteList">
                <el-form class="formBox">
                    <el-form-item label="医院名称" label-width="160px" required>
                        <div class="inputs">
                            <el-input v-model="newform.newHname" placeholder="请输入医院名称"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="详细地址" label-width="160px" required>
                        <div class="inputs">
                            <el-input v-model="newform.newAddress" placeholder="请输入详细地址"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="负责人" label-width="160px">
                        <div class="inputs">
                            <el-input v-model="newform.newPerson" placeholder="请输入负责人"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="负责人联系方式" label-width="160px">
                        <div class="inputs">
                            <el-input v-model="newform.newPhone" placeholder="请输入负责人联系方式"></el-input>
                        </div>
                    </el-form-item>
                <el-form-item>
                    <el-button style="margin-left: 200px;" type="primary" @click="addHostital()">创建医院</el-button>
                </el-form-item>
                    <!-- <el-form-item label="分院名称" label-width="80px">
                        <div class="inputs">
                            <el-input v-model="newform.newBranchHospital" placeholder="请输入分院名称"></el-input>
                        </div>
                    </el-form-item> -->
                </el-form>
            </div>
		</el-dialog>

        
        
        <el-dialog :visible.sync="dialogVisible2" 
            width="540px"
            :close-on-click-modal="false"
            title="上传认证"
            :destroy-on-close="true"
            >
            <div class="noteList">
                <el-form class="formBox form2">
                    <el-form-item label="证书编号" v-if="form.registerediidentity == 4 || form.registerediidentity == 5 || form.registerediidentity == 7" label-width="80px" required>
                        <div class="inputs">
                            <el-input v-model="form2.qualificatioNumber" placeholder="请输入"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="证书照片" label-width="80px" required>
                        <el-upload
                            class="avatar-uploader"
                            action="https://appinterface.chongyike.com/webhttp/mobileHandler/"
                            style="border-radius: 5px;"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess2"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="form2.authenticationImg" :src="form2.authenticationImg" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div class="titlesss">上传证书</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button style="margin-left: 200px;" type="primary" @click="userAuthentication()">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
		</el-dialog>
    </div>
</template>

<script> 
    export default {
        data() {
            return {
                imgSrc: "https://case.chongyike.com",
                // 医院选择框
                dialogVisible: false,
                dialogVisible1: false,
                dialogVisible2: false,
                // 展示头像
                imageUrl: '',
                // 账号
                userPhone: "",
                // 医院搜索参数
                hospitKeyword: "",
                form: {
                    // 昵称
                    name: '',
                    // 姓名
                    realname: '',
                    // 性别
                    gender: '男',
                    // 邮箱地址
                    email: '',
                    // 注册身份
                    registerediidentity: '',
                    // 医院
                    hospitName: "选择医院",
                    hospitno: "",
                },
                // 图片文件
                uploadImg: {},
                form2: {
                    qualificatioNumber: "",
                    authenticationImg: "",
                },
                // 注册身份列表
                registerediidentityList: [{
                        label: "学生",
                        value: "0"
                    },{
                        label: "医药从业人员",
                        value: "1"
                    },{
                        label: "医生(无兽医资格证)",
                        value: "2"
                    },{
                        label: "宠医助理(无兽医资格证)",
                        value: "3"
                    },{
                        label: "医生(有兽医资格证)",
                        value: "4"
                    },{
                        label: "宠医助理(有兽医资格证)",
                        value: "5"
                    },{
                        label: "院长(无兽医资格证)",
                        value: "6"
                    },{
                        label: "院长(有兽医资格证)",
                        value: "7"
                    },
                ],
                options1: [],
                options2: [],
                options3: [],
                value1: '',
                value2: '',
                value3: '',
                hospitTableData: [],
                // 新建医院信息
                newform: {
                    newHname: '',
                    newAddress: '',
                    newPerson: '',
                    newPhone: '',
                    newBranchHospital: '',
                },
                // 认证状态
                Statue: "", 
                Remarks3: "", 
                Userlevel: "", 
            }
        },
        mounted(){
            const that = this
            that.getUserInfo()
            that.getPrvcitareList()
        },
        watch:{
            value1(newVal, oldVal){
                const that = this
                for (let i = 0; i < that.options1.length; i++) {
                    if(that.options1[i].provinceID == newVal){
                        that.options2 = that.options1[i].cityList
                    }
                }
            },
            value2(newVal, oldVal){
                const that = this
                for (let i = 0; i < that.options2.length; i++) {
                    if(that.options2[i].cityID == newVal){
                        that.options3 = that.options2[i].areaList
                    }
                }
            },
        },
        methods: {
            onSubmit() {
                console.log('submit!');
            },
            openNewHospial(){
                const that = this
                if(that.value3 == ''){
                    that.$message({
                        showClose: true,
                        message: "请选择地区",
                    });
                    return false
                }else {
                    that.dialogVisible1 = true
                }
            },
            // 修改用户信息
            updateUser(){
                const that = this
                var genderNo
                if(that.form.gender == "男"){
                    genderNo = 0
                }else {
                    genderNo = 1
                }
                console.log(that.form)
                var data = {
                    type: 'updateUser',
                    name: that.form.name,
                    realname: that.form.realname,
                    gender: genderNo,
                    email: that.form.email,
                    registerediidentity: that.form.registerediidentity,
                    hospitno: that.form.hospitno,
                }
                var uploadFile = new FormData();
                uploadFile.append("userHeadPortrait", that.uploadImg);
                this.post("/user/handler", data, uploadFile).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        console.log(result)
                        that.$message({
                            showClose: true,
                            message: "保存成功",
                            type: "success"
                        });
                    }
                })
            },
            // 获取用户信息
            getUserInfo(){
                const that = this
                var data = {
                    type: 'getUserInfo',
                }
                this.get("/3/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        console.log(result)
                        that.imageUrl = that.imgSrc + result.HeadPortrait
                        that.form.name = result.name
                        that.form.realname = result.realname
                        that.form.email = result.email
                        that.form.registerediidentity = result.RegisteredIidentity
                        that.form.hospitName = result.InaugurationHospital
                        that.form.hospitno = result.Remarks7
                        that.Statue = result.Statue
                        that.Remarks3 = result.Remarks3
                        that.Userlevel = result.Userlevel
                        if(result.gender == "0"){
                            that.form.gender = "男"
                        }else if(result.gender == "1"){
                            that.form.gender = "女"
                        }
                        that.userPhone = result.phone.slice(0,3) + "****" + result.phone.slice(7,11)
                    }
                })
            },
            // 获取省市区
            getPrvcitareList(){
                const that = this
                var data = {
                    type: 'getPrvcitareList',
                }
                this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        console.log(result)
                        that.options1 = result
                    }
                })
            },
            // 获取医院列表
            getHospitList(){
                const that = this
                if(that.value3 == ''){
                    that.$message({
                        showClose: true,
                        message: "请选择地区",
                    });
                    return false
                }
                if(that.hospitKeyword.trim() == ''){
                    that.$message({
                        showClose: true,
                        message: "请输入医院名称",
                    });
                    return false
                }
                var data = {
                    type: 'getHospitList',
                    areaNo: that.value3,
                    keyword: that.hospitKeyword
                }
                this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        console.log(result)
                        that.hospitTableData = result
                    }
                })
            },
            // 新建医院
            addHostital(){
                const that = this
                var hType = 0
                // 学生=学校  医药从业人员=公司 其余为医院
                if(that.registerediidentity == 0){
                    hType = 1
                }else if(that.registerediidentity == 1){
                    hType = 2
                }
                if(that.newform.newHname.trim() == ''){
                    that.$message({
                        showClose: true,
                        message: "请输入医院名称",
                    });
                    return false
                }
                if(that.newform.newAddress.trim() == ''){
                    that.$message({
                        showClose: true,
                        message: "请输入详细地址",
                    });
                    return false
                }
                var data = {
                    type: 'addHostital',
                    hType: hType,
                    name: that.newform.newHname,
                    areaId: that.value3,
                    address: that.newform.newAddress,
                    person: that.newform.newPerson,
                    person: that.newform.newPhone,
                    branchHospital: that.newform.newBranchHospital,
                }
                this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.form.hospitName = result.Name
                        that.form.hospitno = result.No
                        that.dialogVisible = false
                        that.dialogVisible1 = false
                        that.$message({
                            showClose: true,
                            message: "创建成功",
                            type: "success"
                        });
                    }
                })
            },
            // 选择医院
            handleClick(item){
                console.log(item)
                const that = this
                that.form.hospitName = item.Name
                that.form.hospitno = item.No
                that.dialogVisible = false
            },
            // 上传认证
            userAuthentication(){
                const that = this
                var authenticationType = 1
                if(that.form.registerediidentity == 4 || that.form.registerediidentity == 5 || that.form.registerediidentity == 7){
                    authenticationType = 2
                }
                var data = {
                    type: 'userAuthentication',
                    registerediidentity: that.form.registerediidentity,
                    hospitalNo: that.form.hospitno,
                    realName: that.form.realname,
                    authenticationType: authenticationType,
                    qualificatioNumber: that.form2.qualificatioNumber,
                }
                var uploadFile = new FormData();
                uploadFile.append("authenticationImg", that.uploadImg2);
                uploadFile.append("realName",  that.form.realname);
                this.post("/user/handler", data, uploadFile).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        console.log(result)
                        that.dialogVisible2 = false
                        that.$message({
                            showClose: true,
                            message: res.data.result,
                            type: 'success'
                        });
                    }
                })
            },
            handleAvatarSuccess(res, file) {
                console.log(file)
                this.uploadImg = file.raw
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            handleAvatarSuccess2(res, file) {
                console.log(file)
                this.uploadImg2 = file.raw
                this.form2.authenticationImg = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                // const isJPG = file.type === 'image/jpeg';
                // const isLt2M = file.size / 1024 / 1024 < 2;
                return true;
            }
        }
    }
</script>

<style scoped lang="scss">
    ::v-deep .inputs .el-input__inner {
        width: 300px;
        border-radius: 5px !important;
        border:  1px solid #DCDFE6;
        background-color: #fff !important; /* 使用 !important 确保样式覆盖 */
    }
    ::v-deep .avatar-uploader .el-upload {
        border: 1px dashed #ccc;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    ::v-deep .form2 .avatar-uploader .el-upload {
        border: 1px dashed #ccc;
        border-radius: 5px;
        width: 120px;
        height: 150px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        .avatar {
            width: 120px;
            height: 150px;
        }
    }
    ::v-deep .form2 .el-icon-plus {
        font-size: 13px;
    }
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .formBigBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 60%;
            padding: 20px;
            border-radius: 20px;
            box-shadow: 0 0 10px 5px #e1e1e1;
            margin-bottom: 20px;
        }
        .formTitle {
            width: 90%;
            padding-left: 10px;
            border-left: 5px solid #206daf;
        }
        .clickBox {
            padding-top: 20px;
            width: 80%;
            span {
                cursor: pointer;
                color: #206daf;
            }
        }
        .formBox {
            width: 380px;
            .changeHospit {
                width: 300px;
                width: 300px;
                border-radius: 5px;
                color: #606266;
                padding: 0 15px;
                border: 1px solid #DCDFE6;
                background-color: #fff;
                cursor: pointer;
            }
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 78px;
            height: 78px;
            line-height: 78px;
            text-align: center;
        }
        .avatar {
            width: 78px;
            height: 78px;
            display: block;
        }

        .noteList {
            .selectBox {
                margin-bottom: 10px;
            }
            .searchVal {
                width: 500px;
                margin-right: 10px;
            }
            .searchInput {
                margin-bottom: 10px;
            }
        }
    }
</style>